<div class="flex flex-wrap gap-x-4 gap-y-2 w-full">
  <ng-content></ng-content>
</div>
